// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2mhGe","inner":"Form_inner__3m0S9","range":"Form_range__1Tq8T","name":"Form_name__MzI2n","actions":"Form_actions__3ASQI"};